import { Config, Feature } from '../shared/types/ast';

const readConfig = () => {
    if (document) {
        const horseshoeConfig = document.getElementById('horseshoe-config');
        if (horseshoeConfig && horseshoeConfig.innerHTML) {
            return JSON.parse(horseshoeConfig.innerHTML) as Config;
        }
    }
    return;
};
let config = readConfig();

export const getConfig = () => {
    if (!config) {
        config = readConfig();
    }
    return config;
};

export const getFeatureStatus = (toggleName: string): boolean => {
    const config = getConfig();
    return (
        config?.features?.find(
            (i) => i.feature.toLowerCase() === toggleName.toLowerCase(),
        )?.enabled || false
    );
};

export const getDeatiledFeature = (toggleName: string): Feature | undefined => {
    const config = getConfig();
    return config?.features?.find(
        (i) => i.feature.toLowerCase() === toggleName.toLowerCase(),
    );
};
